(function () {
  const backArrow = () => {
    const a = document.createElement("a");

    a.classList.add("back-arrow");

    const pathname = window.location.pathname;
    const backUrl = pathname.substring(0, pathname.lastIndexOf("/")) || "/";

    a.setAttribute("href", backUrl);

    a.innerHTML = `
    <svg width="47px" height="61px" viewBox="0 0 47 61" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="v" stroke="#da2a1c" stroke-width="1" fill="none" fill-rule="evenodd">
            <polyline id="Path" stroke="#979797" transform="translate(23.000000, 29.678082) rotate(-90.000000) translate(-23.000000, -29.678082) " points="-6.17808219 52.1780822 23 7.17808219 52.1780822 52.1780822"></polyline>
        </g>
    </svg>
  `;
    document.querySelector("article.container")?.prepend(a);
  };

  const moreInSummary = () => {
    for (const summary of document.querySelectorAll(".summary")) {
      const el = document.createElement("span");
      el.classList.add("more");
      el.innerHTML = `
        <svg width="113px" height="113px" viewBox="0 0 113 113" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <circle id="Oval" fill="#D8D8D8" cx="56.5" cy="56.5" r="56.5"></circle>
                <g id="Group" transform="translate(25.184688, 25.675532)" stroke="#979797">
                    <line x1="31.315312" y1="0" x2="31.315312" y2="62.6306241" id="Path"></line>
                    <line x1="31.315312" y1="0" x2="31.315312" y2="62.6306241" id="Path" transform="translate(31.315312, 31.315312) rotate(-90.000000) translate(-31.315312, -31.315312) "></line>
                </g>
            </g>
        </svg>
        `;

      const img = summary.querySelector("img");

      if (img) {
        summary.insertBefore(el, img);
      } else {
        summary.append(el);
      }
    }
  };

  window.addEventListener("DOMContentLoaded", () => {
    backArrow();
    moreInSummary();
  });
})();
